/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Passkey_ActiveInputs */



/**
* | output |
* | --- |
* | "Active" |
*
* @param {Profile_Passkey_ActiveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_passkey_active = /** @type {((inputs?: Profile_Passkey_ActiveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Passkey_ActiveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actif")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ativo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attivo")
	return /** @type {LocalizedString} */ ("Active")
});